export type FormTab = 'submissions' | 'fields' | 'stages' | 'rules' | 'api' | 'settings';

/** Вкладка формы из адреса; «Заявки» — по умолчанию, в адресе не пишется. */
export function isFormTab(value: unknown): value is Exclude<FormTab, 'submissions'> {
  return (
    value === 'fields' ||
    value === 'stages' ||
    value === 'rules' ||
    value === 'api' ||
    value === 'settings'
  );
}
